module.exports = __webpack_public_path__ + "img/igcolor.1099fb6e.png";